import React, { useEffect, useRef, useState } from "react"
import"../style/imags.css"
import { useSpring, animated } from 'react-spring';





export function ImagesComp(props)
{

let {imgSrc}=props
console.log(imgSrc);
 let imgRef=useRef()
let [width,setWidth]=useState()
let [heigth,setHeigth]=useState()
 const calc = (x, y) => [
    -(y - window.innerHeight / 2) / 20,
    (x - window.innerWidth / 2) / 20,
    1.0,
   
  ];

  
  const perspective = (x, y, s) =>
  `perspective(500px) 
   rotateX(${x+5}deg) 
   rotateY(${y-10}deg) 
   scale(${s})`;
  

   const [tilte, set] = useSpring(() => ({
    xys: [-7, 11, 0.9],
    config: { mass: 5, tension: 200, friction: 100 },
  }));




 
//  console.log(heigth,width );
    return(
        <div className="images_main_container">
          
          <div className="imag_boxOne" 
           
         >
< animated.img ref={imgRef}

onMouseMove={({ clientX: x, clientY: y }) => {
  
    set({ xys: calc(x, y) });setHeigth({clientY: y});setWidth({clientX: x}) }}
           onMouseLeave={() => set({ xys: [-7, 11, 0.9] })}
           style={{ transform: tilte.xys.interpolate(perspective) }} src={imgSrc}/>
          </div>
        </div>
    )
}


export function ImagesCompLeft(props)
{

let {imgSrc}=props
console.log(imgSrc);
 let imgRef=useRef()
let [width,setWidth]=useState()
let [heigth,setHeigth]=useState()
 const calc = (x, y) => [
    -(y - window.innerHeight / 2) / 20,
    (x - window.innerWidth / 2) / 20,
    1.0,
   
  ];

  
  const perspective = (x, y, s) =>
  `perspective(500px) 
   rotateX(${x}deg) 
   rotateY(${y+17}deg) 
   scale(${s})`;
  

   const [tilte, set] = useSpring(() => ({
    xys: [0, -17, 0.9],
    config: { mass: 5, tension: 200, friction: 100 },
  }));




 
//  console.log(heigth,width );
    return(
        <div className="images_main_container">
          
          <div className="imag_boxOne" 
           
         >
< animated.img ref={imgRef}

onMouseMove={({ clientX: x, clientY: y }) => {
  
    set({ xys: calc(x, y) });setHeigth({clientY: y});setWidth({clientX: x}) }}
           onMouseLeave={() => set({ xys: [0, -17, 0.9] })}
           style={{ transform: tilte.xys.interpolate(perspective) }} src={imgSrc}/>
          </div>
        </div>
    )
}